<template>
    <div class="progress-circular">
        <svg class="progress-ring" :width="radius * 2 + 20" :height="radius * 2 + 20">
            <circle
                class="progress-ring__bg"
                :stroke-width="strokeWidth"
                fill="transparent"
                :r="radius"
                :cx="radius + 10"
                :cy="radius + 10"
            />
            <circle
                ref="ring"
                class="progress-ring__circle"
                :class="color"
                :stroke-width="strokeWidth"
                fill="transparent"
                :r="radius"
                :cx="radius + 10"
                :cy="radius + 10"
                :style="`stroke-dashoffset: ${offset}; stroke-dasharray: ${circumference} ${circumference}`"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'ProgressCircular',
    props: {
        value: {
            type: Number,
            default: 0,
        },
        radius: {
            type: Number,
            default: 17,
        },
        strokeWidth: {
            type: Number,
            default: 6,
        },
    },
    data() {
        return {
            circumference: 0,
        }
    },
    computed: {
        offset() {
            return this.circumference - (this.value / 100) * this.circumference
        },
        color() {
            if (this.value < 80) {
                return 'green'
            } else if (this.value >= 80 && this.value < 100) {
                return 'yellow'
            } else {
                return 'red'
            }
        },
    },
    mounted() {
        this.getCircumference()
    },
    methods: {
        getCircumference() {
            const circle = this.$refs.ring
            const radius = circle.r.baseVal.value
            this.circumference = radius * 2 * Math.PI
        },
    },
}
</script>

<style scoped lang="sass">
.progress-circular
    display: grid
    place-content: center
    svg
        .progress-ring__circle
            transform: rotate(-90deg)
            transform-origin: 50% 50%
            stroke-linecap: round
            +transition(200ms)

        .progress-ring__bg
            stroke: $gray-1


    .green
        stroke: $green

    .yellow
        stroke: $yellow

    .red
        stroke: $red
</style>
